import { AccessMenu } from 'commons/modules/access-by-menu';
import { ItemSidebarMenu } from 'commons/modules/SidebarMenu/item-sidebar-menu';
import { arrayValidation } from 'utils/array';
import { itemsMenu } from './itemsData';

const accessDenied: Record<string, boolean> = {
  otro: false,
};

const accessTypeToShowTheScreen = ['edit', 'readOnly'];

const getAccessMenu = (itemMenu: AccessMenu) => {
  if (!arrayValidation(itemMenu.accessRoles)) return { ...accessDenied };
  const access: Record<string, boolean> = { ...accessDenied };
  itemMenu.accessRoles.forEach((item) => {
    access[item.role] = accessTypeToShowTheScreen.includes(item.accessType);
  });

  return access;
};

const getAccessScreen = (itemMenu: AccessMenu, screenKey: string) => {
  if (!arrayValidation(itemMenu.screens)) return { ...accessDenied };

  const screen = itemMenu.screens.find((item) => item.screenKey === screenKey);

  if (!screen) return { ...accessDenied };

  const access: Record<string, boolean> = { ...accessDenied };

  screen.accessRoles.forEach((item) => {
    access[item.role] = accessTypeToShowTheScreen.includes(item.accessType);
  });

  return access;
};

const addAccessScreens = (
  itemMenu: AccessMenu,
  itemSidebarMenu: ItemSidebarMenu,
) => {
  itemSidebarMenu.options.forEach((option) => {
    option.access = getAccessScreen(itemMenu, option.screenKey || '');

    const screen = itemMenu.screens.find(
      (s) => s.screenKey === option.screenKey,
    );
    if (screen?.exclusiveByOffice) {
      option.exclusiveByOffice = screen.exclusiveByOffice;
    }
  });
};

export const getItemsMenuByAccess = (
  accessByMenu: AccessMenu[],
): ItemSidebarMenu[] => {
  return itemsMenu.map((item) => {
    const itemMenu = accessByMenu.find(
      (menu) => menu.menuKey === item.menuKey,
    );

    if (!itemMenu) {
      return {
        ...item,
        access: accessDenied,
        options: item.options.map((option) => ({
          ...option,
          access: { ...accessDenied },
        })),
      };
    }

    const newItem: ItemSidebarMenu = {
      ...item,
      access: getAccessMenu(itemMenu),
      options: item.options.map((option) => ({
        ...option,
        access: { ...accessDenied },
      })),
    };

    if (itemMenu.exclusiveByOffice) {
      newItem.exclusiveByOffice = itemMenu.exclusiveByOffice;
    }

    addAccessScreens(itemMenu, newItem);
    return newItem;
  });
};
